var image_viewer_rtlignore_default = {
  "fontElementMap": "Yu1FJ",
  "imageContainer": "-v9Bf",
  "expandContainer": "VRi8F",
  "expandIcon": "hGngR",
  "pointer": "drtqG",
  "imageWrapper": "suFIY",
  "imageRatio": "-qM37",
  "image": "MtuOD",
  "imageOverlay": "H84-u",
  "imagePreload": "BHRVg",
  "imageHighres": "CCEwI",
  "onlyHighRes": "d3jHw",
  "image_loading": "_2A8RN"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
